import * as headerBlock from './header/index';
import * as loginForm from './login/index';
import * as home from './home/index';

export default {
  name: 'main',
  props: [
    'onLogout',
    'onLogin',
    'access_token',
    'authUser',
  ],
  components: { headerBlock, loginForm, home },
  data() {
    return {};
  },
  created() {},
  methods: {
    sendAuth(access_token, user) {
      // this.$http.post('authorize/', { username: data[0], password: data[1] },
      //   {
      //     method: 'POST',
      //     headers: {},
      //   })
      //   .then((response) => {
      //     if (response.status !== 200) {
      //       console.log(response);
      //       return;
      //     }
      //     console.log(response);
      //     this.$emit('onLogin', response.body.access_token, response.body.user);
      //   });
      this.$emit('onLogin', access_token, user);
    },
    redirect: function(url) {
      this.$router.push(url);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Main.controller.js